export default __webpack_public_path__ + "static/media/5.ad64d42b.svg";